import * as THREE from '@blade-sxp/map/src/objects/three.js';
import { Group, Mesh, Vector3, } from 'three';
import { ELementType } from '@blade-sxp/map/src/element';
import TWEEN from '@tweenjs/tween.js';
import { FPS } from '@blade-sxp/map/src/config';
// import {loadePerson,Gender, ModelType,clipAnimation} from '@blade-sxp/map/utils/persons';
import { loadeModel, Model, clipAnimation } from '@blade-sxp/map/utils/loadModels';
import { clone } from 'three/examples/jsm/utils/SkeletonUtils.js';
class Persons extends Group {
    add;
    props;
    isLoaded;
    isObserver;
    disposeStatus = false;
    circle;
    circleInstance;
    animateId = -1;
    tweens;
    animate; // 动画
    personGltfMap = {}; // 存储对应性别的小人数据
    persons; // 存储每个id对应的小人；
    personsInstanceMap;
    startMovePoint; // 需要移动点位的集合
    endMovePoint; // 需要移动的结束点位 
    countPersons; // 计数小人对应性别动画的小人信息
    time;
    renderT = 1 / FPS;
    _scaleNum = 100;
    get scaleNum() {
        return this._scaleNum;
    }
    set scaleNum(val) {
        this._scaleNum = val;
    }
    constructor(data) {
        super();
        this.isObserver = false;
        this.isLoaded = false;
        this.personGltfMap = {};
        this.name = this.uuid;
        this.props = data;
        this.persons = new Map();
        this.personsInstanceMap = new Map();
        this.startMovePoint = {};
        this.endMovePoint = {};
        this.circle = new THREE.Mesh(new THREE.CircleGeometry(0.4, 32), new THREE.MeshBasicMaterial({
            side: THREE.DoubleSide,
            transparent: true,
            opacity: 0.9,
            depthTest: true,
        }));
        this.circle.rotation.x = Math.PI * 0.5;
        this.tweens = new TWEEN.Tween();
        // 顺序不可变
        // 加载男女未知模型
        this.initPersonsGltf(() => {
            // this.initPersonList(); // 实例化男女未知模型以及数量， 收集移动点位
            // this.initCirCleInstance(); //  实例化男女未知模型脚下的圆圈
            this.update(data);
            let timeNow = 0;
            const renderT = this.renderT;
            const clock = new THREE.Clock();
            this.animate = (time) => {
                this.animateId = window.requestAnimationFrame(this.animate);
                const mixerUpdateDelta = clock.getDelta();
                timeNow = timeNow + mixerUpdateDelta;
                if (timeNow > renderT) {
                    this.updateMixer(mixerUpdateDelta);
                    timeNow = 0;
                }
                this.time = timeNow;
            };
            this.animate();
            this.isLoaded = true;
        });
    }
    updateMixer(time) {
        const personsInstanceMap = this.personsInstanceMap;
        personsInstanceMap.forEach((val) => {
            const { mixer } = val;
            mixer?.update(time);
        });
    }
    update(data) {
        if (!this.isLoaded || data.list === this.props?.list) {
            this.props = data;
            return;
        }
        this.initPersonList(data);
        this.tweens.stop();
        this.movePoints(data);
    }
    // 动作分类
    actionClassify() {
        const action = {
            wait: {},
            walk: {},
        };
        this.personsInstanceMap.forEach((item, key) => {
            const isWalk = key.indexOf('walk') !== -1;
            const isWait = key.indexOf('wait') !== -1;
            isWalk && (action.walk[key] = item);
            isWait && (action.wait[key] = item);
        });
        return action;
    }
    // 执行动作
    doAction(actionPersons, isFadeToAction = false) {
        for (const k in actionPersons) {
            const { animations } = actionPersons[k];
            const { animationName = null } = this.countPersons?.[k] ?? {};
            if (!animationName)
                continue;
            const action = animations?.[animationName];
            if (isFadeToAction) {
                const waitAction = animations.wait;
                this.fadeToAction(waitAction, action);
            }
            else {
                action && this.fadeToAction(action);
            }
        }
    }
    movePoints(data) {
        const startMovePoint = this.startMovePoint;
        const endMovePoint = this.endMovePoint;
        const { wait, walk } = this.actionClassify();
        this.doAction(wait);
        this.tweens = new TWEEN.Tween(startMovePoint);
        if (this.isLoaded) {
            this.tweens
                .to(endMovePoint, 2300)
                .onUpdate((obj) => {
                if (this.disposeStatus) {
                    this.tweens.stop();
                }
                this.updatePersonPosition(walk, obj);
            })
                .onStop(() => {
                // if (this.disposeStatus) return;
                this.doAction(walk, true);
            })
                .onComplete(() => {
                this.props = data;
                this.updatePersonPosition(walk, endMovePoint);
                this.doAction(walk, true);
                // console.log('onComplete' );
            })
                .onStart(() => {
                this.doAction(walk);
                this.updatePersonPosition(walk, startMovePoint, true);
            })
                .start();
        }
    }
    /**
     * 移动到对应点位
     * @param {{[k:string]:Vector3}} movePoint: 对应id的移动点位
     * @param {boolean} isUpdateCurrentPosition: 是否更新当前点位
    */
    updatePersonPosition(personsInstanceInfo, movePoints, isUpdateCurrentPosition = false) {
        // const instanceObj:{[k:string]: InstancedSkinnedMesh}= {};
        const movePersons = {};
        // const promises: Function[] = [];
        // let count = 0;
        for (const k in personsInstanceInfo) {
            const fn = () => {
                const { instance, gender, person } = personsInstanceInfo[k];
                const personsInfo = this.countPersons[k];
                personsInfo?.list?.forEach(item => {
                    const { id, circleIndex, personIndex, rotation, signalColor } = item;
                    const position = isUpdateCurrentPosition ? item.position : { x: movePoints[`x_${id}`], y: movePoints[`y_${id}`], z: movePoints[`z_${id}`] };
                    let curRotation = rotation;
                    // 更新当前小人位置
                    const mapPerson = this.persons.get(id);
                    if (isUpdateCurrentPosition) {
                        const normalVector = new THREE.Vector3();
                        const currentVector3 = new THREE.Vector3(0, 0, 1);
                        const _position = new THREE.Vector3(position.x, 0, position.z).sub(new THREE.Vector3(item.currentPosition.x, 0, item.currentPosition.z));
                        if (_position.length() !== 0) {
                            normalVector.crossVectors(currentVector3, _position); // 坐标平面法线
                            const isReverse = normalVector.y > 0;
                            const angle = currentVector3.angleTo(_position);
                            const realAngle = isReverse ? angle : -angle;
                            mapPerson.rotation = realAngle;
                            curRotation = realAngle;
                        }
                    }
                    person.position.set(position.x, position.y, position.z);
                    mapPerson.currentPosition = { x: position.x, y: position.y, z: position.z };
                    person.rotation.y = curRotation;
                    person.updateMatrix();
                    instance.setMatrixAt(personIndex, person.matrix);
                    instance.setBonesAt(personIndex, person.skeleton);
                    // 添加脚下圆圈
                    this.circle.position.set(position.x, position.y, position.z);
                    this.circle.updateMatrix();
                    this.circleInstance.setMatrixAt(circleIndex, this.circle.matrix);
                    this.circleInstance.setColorAt(circleIndex, new THREE.Color(signalColor).convertSRGBToLinear());
                });
                instance.instanceMatrix.needsUpdate = true;
                if (instance.skeleton && instance.skeleton.boneTexture) {
                    instance.skeleton.boneTexture.needsUpdate = true;
                }
                if (instance.skeleton && instance.skeleton.boneTexture) {
                    instance.skeleton.boneTexture.needsUpdate = true;
                }
                this.circleInstance.instanceMatrix.needsUpdate = true;
                if (this.circleInstance.instanceColor) {
                    this.circleInstance.instanceColor.needsUpdate = true;
                }
            };
            fn();
        }
    }
    //  实例化男女未知模型脚下的圆圈
    initCirCleInstance() {
        this.circleInstance = new THREE.InstancedMesh(this.circle.geometry, this.circle.material, this.persons.size);
    }
    initPersonInstance(countPersons) {
        // 生成男、女、未知 实例化小人
        for (const k in countPersons) {
            const { count, gender, list } = countPersons[k];
            const gltfInfo = this.personGltfMap?.[gender];
            if (!gltfInfo)
                continue;
            const animations = gltfInfo.animations;
            const personScene = clone(gltfInfo.scene);
            const mixer = new THREE.AnimationMixer(personScene);
            const clicpAnimations = clipAnimation(mixer, animations, ['wait', 'walk']);
            const person = (personScene?.getObjectByName('Mod_Human'));
            if (person) {
                const { geometry, material } = person;
                if (geometry && material) {
                    const instance = new THREE.InstancedSkinnedMesh(geometry, material, count);
                    instance.copy(person);
                    person.visible = false;
                    if (gender === Model.UNKNOWN)
                        person.scale.set(this.scaleNum, this.scaleNum, this.scaleNum);
                    instance.frustumCulled = false; // false:不在摄影机的平截头体中，也会在每帧渲染一次对象
                    // const personGltfInfo = this.personGltfMap?.[k];
                    const personList = list; // personGltfInfo?.list??[];
                    personList.forEach((item) => {
                        const personInfo = this.persons.get(item.id);
                        person.position.set(personInfo.currentPosition.x, personInfo.currentPosition.y, personInfo.currentPosition.z);
                        person.rotation.y = personInfo.rotation;
                        person.updateMatrix();
                        instance.setMatrixAt(personInfo.personIndex, person.matrix);
                        instance.setBonesAt(personInfo.personIndex, person.skeleton);
                        // 添加脚下圆圈
                        this.circle.position.set(personInfo.currentPosition.x, personInfo.currentPosition.y - 0.1, personInfo.currentPosition.z);
                        this.circle.updateMatrix();
                        this.circleInstance.setMatrixAt(item.circleIndex, this.circle.matrix);
                        this.circleInstance.setColorAt(item.circleIndex, new THREE.Color(item.signalColor).convertSRGBToLinear());
                    });
                    instance.instanceMatrix.needsUpdate = true;
                    if (instance.skeleton && instance.skeleton.boneTexture) {
                        instance.skeleton.boneTexture.needsUpdate = true;
                    }
                    if (instance.skeleton && instance.skeleton.boneTexture) {
                        instance.skeleton.boneTexture.needsUpdate = true;
                    }
                    // 更新脚下圆圈
                    this.circleInstance.instanceMatrix.needsUpdate = true;
                    if (this.circleInstance.instanceColor) {
                        this.circleInstance.instanceColor.needsUpdate = true;
                    }
                    // k是有性别+动作组成
                    this.personsInstanceMap.set(k, { instance, animations: clicpAnimations, mixer, person, gender, scene: personScene });
                    this.add(personScene); // 人物场景必须加入才能看到小人
                    this.add(instance);
                    this.add(this.circleInstance);
                    // stand
                    // const mixerStand = new THREE.AnimationMixer(personScene);
                    // mixer.clipAction((animations as any)[1])?.play();
                }
            }
            // personScene.position.set(100, 100, 100);
            // this.add(personScene);
        }
    }
    initPersonList(data) {
        const countPersons = {};
        const tempPersons = new Map();
        this.startMovePoint = {};
        this.endMovePoint = {};
        const genderCount = {};
        const peerNum = 50;
        // 封装小人数据
        data.list?.map((item, index) => {
            const platformName = `${ELementType.Roi3d}${item?.renderProps.platformId}`;
            const position = this.props.getPointInMesh(platformName, { x: item.position.x, y: item.position.y });
            const personId = item.id;
            let currentPosition = position;
            if (!position)
                return;
            const gender = item.renderProps.gender;
            const _obj = this.persons.get(item.id);
            let animationName = _obj?.animation ?? 'wait';
            if (_obj) {
                const _position = new THREE.Vector3(_obj.position.x, 0, _obj.position.z).sub(new THREE.Vector3(_obj.currentPosition.x, 0, _obj.currentPosition.z));
                currentPosition = _obj.currentPosition;
                if (_position.length() !== 0) {
                    // 收集位移点位
                    this.startMovePoint[`x_${personId}`] = currentPosition.x;
                    this.startMovePoint[`y_${personId}`] = currentPosition.y;
                    this.startMovePoint[`z_${personId}`] = currentPosition.z;
                    // this.startMovePoint[item.id];
                    // this.endMovePoint[item.id as string] = position;
                    this.endMovePoint[`x_${personId}`] = position.x;
                    this.endMovePoint[`y_${personId}`] = position.y;
                    this.endMovePoint[`z_${personId}`] = position.z;
                    const normalVector = new THREE.Vector3();
                    normalVector.crossVectors(currentPosition, _position); // 坐标平面法线
                    const isReverse = normalVector.y > 0;
                    const angle = currentPosition?.angleTo?.(_position);
                    if (angle) {
                        const realAngle = isReverse ? angle : -angle;
                        _obj.rotation = realAngle;
                    }
                    animationName = 'walk';
                }
                // else {
                //   // 行走的人变为站立
                //   const {animations = null} =   this.personsInstanceMap.get(_obj.groupId)?? {};
                //   if(animations && _obj?.animationName === 'walk'){
                //     this.fadeToAction(animations?.wait, animations?.walk);
                //   }
                // }
            }
            const genderKey = gender + animationName;
            const countKey = genderKey + (genderCount?.[genderKey]?.count ?? '');
            // 相同性别动作小人分片
            if (countPersons[countKey] && countPersons[countKey].count === peerNum) {
                if (!genderCount[genderKey]) {
                    genderCount[genderKey] = { count: 0 };
                }
                genderCount[genderKey].count++;
            }
            if (!countPersons[countKey]) {
                countPersons[countKey] = { count: 0, list: [], gender: gender, animationName };
            }
            const person = {
                id: personId,
                groupId: countKey,
                gender: gender,
                position: position,
                rotation: _obj?.rotation ?? 0,
                currentPosition: currentPosition,
                normalVector: new Vector3(0, 0, 1),
                signalColor: item?.renderProps?.signalColor,
                platformId: item?.renderProps?.platformId,
                circleIndex: index,
                previousanimationName: _obj?.animation,
                animationName: animationName,
                personIndex: countPersons[countKey].count,
            };
            tempPersons.set(item.id, person);
            countPersons[countKey].count++;
            countPersons[countKey].list.push(person);
        });
        // 销毁之前小人
        this.disposePerson();
        this.persons = tempPersons;
        this.countPersons = countPersons;
        this.initCirCleInstance();
        this.initPersonInstance(countPersons);
    }
    ;
    filterAnimation(animation, filterArr) {
        const animationMap = {};
        for (const k in animation) {
            const targetKey = filterArr.find(key => k.toLocaleLowerCase().indexOf(key) !== -1);
            if (targetKey) {
                const val = animation[k];
                animationMap[targetKey] = val;
            }
        }
        return animationMap;
    }
    // 执行动画
    fadeToAction(action, previousAction) {
        const time = previousAction ? 0.5 : 1.0;
        if (previousAction) {
            previousAction?.fadeOut(time);
        }
        action.reset().setEffectiveTimeScale(1).setEffectiveWeight(1).fadeIn(time).play();
    }
    async initPersonsGltf(call) {
        // const personKeys = [ Model.UNKNOWN];//  [Model.MALE, Model.FEMALE, Model.UNKNOWN];
        const personKeys = [Model.MALE, Model.FEMALE, Model.UNKNOWN];
        for (let i = 0; i < personKeys.length; i++) {
            const key = personKeys[i];
            const personInfo = await loadeModel(key);
            this.personGltfMap[key] = { ...personInfo };
        }
        call();
    }
    disposePerson() {
        this.countPersons = {};
        this.personsInstanceMap.forEach(item => {
            const { instance, scene } = item;
            instance?.geometry?.dispose();
            instance.material?.dispose();
            this.remove(instance);
            this.remove(scene);
        });
        this.personsInstanceMap.clear();
        this.circleInstance?.geometry.dispose();
        this.circleInstance?.material?.dispose();
        this.remove(this.circleInstance);
    }
    dispose() {
        const { onDestory } = this.props;
        window.cancelAnimationFrame(this.animateId);
        this.disposeStatus = true;
        this.traverse(function (obj) {
            if (obj instanceof Mesh) {
                obj.geometry?.dispose();
                obj.material?.dispose();
            }
            else {
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            }
        });
        this.parent?.remove(this);
        this.clear();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
        this.disposePerson();
    }
}
export default Persons;
